import React, { useEffect, useState } from "react";
import "./NotNtworkCard.scss";
import img1 from "../../../Assets/NotNetwork/img/1.png";
import img2 from "../../../Assets/NotNetwork/img/2.png";
import img3 from "../../../Assets/NotNetwork/img/3.png";
 
const NotNtworkCard = () => {
  const [activeMenu, setActiveMenu] = useState(1);
  const langGlobal = localStorage.getItem("lang");

  const lang = {
    titleMoneyTJ: "Ҳаменҳои электронӣ",
    titleMoneyRU: "Электронные кошельки",
    subTitleMoneyRU:
      "Пополните счет через вашу любимую платежную систему. В приложении кошелька выберите «Оплата услуг» → «Интернет-провайдеры» → выберите нас, «NETS». При оплате обязательно укажите ваш лицевой счет.",
    subTitleMoneyTJ:
      'Ҳисобатонро тавассути системаи пардохти дӯстдоштаи худ зуд ва осон пур кунед. Дар барномаи ҳамёни электронӣ "Пардохт" → "Провайдерҳои Интернетӣ" → "NETS"-ро интихоб кунед. Ҳангоми пардохт, рақами суратҳисоби шахсии худро ворид кунед.',
    bankTitleTJ: "Интиқоли бонкӣ",
    bankTitleRU: "Банковский перевод",
    subTitleBankTJ: "Маълумоти бонкии мо бо сомонӣ",
    subTitleBankRU: "Наши банковские реквизиты в сомони",
    bankTranslatedTJ: "Шумо метавонед тавассути бонк пардохтро анҷом диҳед",
    bankTranslatedRU: "Оплата доступна через любой банк",
    bankRecipientTJ: 'Қабулкунанда: ҶДММ "Нет Солюшенс"',
    bankRecipientRU: 'Получатель: ООО "Нет Солюшенс"',
    bankAccountTJ: "Ҳисоби қабулкунанда",
    bankAccountRU: "Счет получателя",
    bankDcTJ: 'Бонки қабулкунанда: ҶСК "Душанбе Сити Банк"',
    bankDcRU: "Банк получателя: ЗАО «Душанбе Сити Банк»",
    bankRpTJ: "Ҳисоби корреспондентӣ: 20402972318411",
    bankRpRU: "Корр. счет: 20402972318411",
    bankEndTitleTJ:
      "Дар таъиноти пардохт ҳатман рақами суратҳисоби шахсии худро нишон диҳед",
    bankEndTitleRU: "Не забудьте указать лицевой счет в назначении платежа",
    tillTitleTJ: "Пули нақд дар касса",
    tillTitleRU: "Наличные деньги в кассах",
    tillSubTitleTJ: `Ба филиалҳои мо муроҷиат намуда, тавозунатонро метавонед пур кунед. Танҳо суратҳисоби шахсии худро ба оператор пешниҳод кунед. Суроға: Шаҳри Душанбе, кӯчаи Пулодӣ, 41, ошёнаи 1.`,
    tillSubTitleRU: `Вы можете внести оплату в любом нашем филиале. Сообщите оператору
              ваш лицевой счет для своевременного зачисления средств. Адрес: г.
              Душанбе, улица Пулоди, 41, 1-й этаж.`,
  };
 
  return (
    <div className="notNtworkCard_block">
      <div className="notNtworkCardTitle_block">
        <div
          className="notNtworkCardTitle_item"
          onClick={() => setActiveMenu(1)}
          style={{ background: activeMenu === 1 && "var(--legacy-surface-f5f4f4)" }}
        >
          <div className="notNtworkCardTitle_img">
            <img src={img1} alt="" />
          </div>
          {activeMenu === 1 && (
            <h4>
              {langGlobal === "TJ" ? lang.titleMoneyTJ : lang.titleMoneyRU}
            </h4>
          )}
        </div>
        <div
          className="notNtworkCardTitle_item"
          onClick={() => setActiveMenu(2)}
          style={{ background: activeMenu === 2 && "var(--legacy-surface-f5f4f4)" }}
        >
          <div className="notNtworkCardTitle_img">
            <img src={img2} alt="" />
          </div>
          {activeMenu === 2 && (
            <h4>{langGlobal === "TJ" ? lang.bankTitleTJ : lang.bankTitleRU}</h4>
          )}
        </div>
        <div
          className="notNtworkCardTitle_item"
          onClick={() => setActiveMenu(3)}
          style={{ background: activeMenu === 3 && "var(--legacy-surface-f5f4f4)" }}
        >
          <div className="notNtworkCardTitle_img">
            <img src={img3} alt="" />
          </div>
          {activeMenu === 3 && <h4>{langGlobal === "TJ" ? lang.tillTitleTJ : lang.tillTitleRU}:</h4>}
        </div>
      </div>
      <div className="notNtworkCard_item">
        {activeMenu === 1 ? (
          <>
            <h4>
              {langGlobal === "TJ" ? lang.titleMoneyTJ : lang.titleMoneyRU}
            </h4>
            <p>
              {langGlobal === "TJ"
                ? lang.subTitleMoneyTJ
                : lang.subTitleMoneyRU}
            </p>
          </>
        ) : activeMenu === 2 ? (
          <>
            <h4>{langGlobal === "TJ" ? lang.bankTitleTJ : lang.bankTitleRU}</h4>
            <p>
              {langGlobal === "TJ"
                ? lang.bankTranslatedTJ
                : lang.bankTranslatedRU}
              . <br />
              {langGlobal === "TJ"
                ? lang.subTitleBankTJ
                : lang.subTitleBankRU}: <br />•{" "}
              {langGlobal === "TJ"
                ? lang.bankRecipientTJ
                : lang.bankRecipientRU}{" "}
              <br />•{" "}
              {langGlobal === "TJ" ? lang.bankAccountTJ : lang.bankAccountRU}:
              20202972000000101676 <br />•{" "}
              {langGlobal === "TJ" ? lang.bankDcTJ : lang.bankDcRU} <br />•{" "}
              {langGlobal === "TJ" ? lang.bankRpTJ : lang.bankDcRU} <br />
              • БИК: 350101841 <br />
              • ИНН: 510022404 <br />
              {langGlobal === "TJ" ? lang.bankEndTitleTJ : lang.bankEndTitleRU}.
            </p>
          </>
        ) : activeMenu === 3 ? (
          <>
            <h4>
              {langGlobal === "TJ" ? lang.tillTitleTJ : lang.tillTitleRU}:
            </h4>
            <p>{langGlobal === "TJ" ? lang.tillSubTitleTJ : lang.tillSubTitleRU}</p>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default NotNtworkCard;
